import { BrowserCacheLocation, InteractionType, LogLevel } from '@azure/msal-browser';
import { Environment } from './environment.model';

export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}
const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1 ||
  window.navigator.userAgent.indexOf('Edge') > -1;

/**
 * This file will be replaced during prod build through the prebuild.js script.
 * That way, prod setting apply for deployed versions.
 */
export const environment: Environment = {
  production: false,
  azureEndpoint: 'https://staging.api.schenck.one',
  apiBaseUrl: 'https://staging.api.schenck.one/um/v2', // against deployed/cloud backend
  usBaseUrl: 'https://staging.api.schenck.one/user', // against deployed/cloud backend
  umBaseUrl: 'https://staging.api.schenck.one/um/v2/rights/UM', // against deployed/cloud backend
  amBaseUrl: 'https://staging.api.schenck.one/am/v1', // against deployed/cloud backend
  googleApiKey: 'AIzaSyCaCOvpgCooOPqfq4yIgpasYKr2-k9xIWQ',
  versionInfo: {
    tag: 'staging',
    hash: '9720802e5b78b03abdba0b8b1f1ed1ca289b3d31',
    buildtimestamp: '2026-10-08T07:25:33.3909208Z',
    buildVersion: '2.1.0+1088',
  },
  msalConfig: {
    msal: {
      auth: {
        clientId: 'ccf2fc8c-44f8-4af8-928f-7f60b16415e1',
        knownAuthorities: ['durrgroupb2c.b2clogin.com'],
        authority: 'https://durrgroupb2c.b2clogin.com/durrgroupb2c.onmicrosoft.com/B2C_1A_SIGNIN',
        redirectUri: 'https://staging.usermanager.schenck.one',
        postLogoutRedirectUri: 'https://staging.usermanager.schenck.one/postlogout',
      },
      cache: {
        cacheLocation: BrowserCacheLocation.SessionStorage,
        storeAuthStateInCookie: true, // set to true for IE 11. Remove this line to use Angular Universal
      },
      system: {
        loggerOptions: {
          loggerCallback,
          logLevel: LogLevel.Info,
          piiLoggingEnabled: false,
        },
      },
    },
    guard: {
      interactionType: InteractionType.Redirect,
      authRequest: {
        scopes: [
          'https://durrgroupb2c.onmicrosoft.com/fe173409-9be8-45ff-a77d-184f3ec74c50/API.All',
        ],
      },
      loginFailedRoute: '/login-failed',
    },
  },
};
